// src/components/header/AppName.tsx
import { styled } from "@mui/material";
import { jsx } from "react/jsx-runtime";
var AppNameTextOpts = { name: "AppNameText", slot: "root" };
var AppNameText = styled("h3", AppNameTextOpts)`
    margin: 0;
    padding: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: ${({ theme }) => theme.font.size["3xl"]};
    color: ${({ theme }) => theme.color.N9.hex};

    @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
        font-size: ${({ theme }) => theme.font.size["2xl"]};
    }
`;
function AppName({ children }) {
  if (children.length > 24) {
    console.warn("The contents of `<AppName>` should be fewer than 25 characters");
  }
  return /* @__PURE__ */ jsx(AppNameText, { children });
}

export {
  AppNameTextOpts,
  AppName
};
//# sourceMappingURL=chunk-J2XSX3HI.js.map